// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 602 ? "component---node-modules-gatsby-theme-garden-src-templates-local-file-js" : chunkId) + "-" + {"552":"c140a11b93643b13ce1e","602":"142196bccd0eda931ef9"}[chunkId] + ".js";
};